import React, { useEffect, useState } from "react";
import { Input, FormGroup, Label, Button } from "reactstrap";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { getAllPlaces } from "../../redux/actions/indexActions";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";

const EditTourCategory = () => {
  const { id } = useParams();
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    status: 1,
    logo: "",
    email:"",
    mobile:"",
    tour_category_id:"",
    place_id:"",
    state:"",
    city:"",
    Language:"",
    Pincode:"",
    Website:"",
  });
  const [errors, setErrors] = useState({});

  const {
    AuthReducer: { auth },
    indexReducer: { places }
  } = useSelector((state) => state);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const inputHandler = (e) => {
    const { name, value } = e.target;
    if (name === "logo") {
      setFormData({ ...formData, [name]: e.target.files[0] });
    }
    if (name === "status") {
      setFormData({ ...formData, [name]: e.target.checked ? 1 : 0 });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = () => {
    const form = new FormData();
    for (const key in formData) {
      form.append([key], formData[key]);
    }
    axios
      .put(`/api/admin/v1/update-tour-category/${id}`, form, {
        headers: {
          Authorization: `Bearer ${auth?.token}`,
        },
      })
      .then((res) => {
        toast.success(res.data?.message);
        navigate(-1);
      })
      .catch((err) => {
        toast.error(err.response.data);
        setErrors(err.response.data);
      });
  };

  useEffect(() => {
    axios(`/api/admin/v1/edit-tour-category/${id}`, {
      headers: {
        Authorization: `Bearer ${auth?.token}`,
      },
    })
      .then((res) => {
        setFormData({
          name: res.data?.tourCategoryedit?.name,
          email: res.data?.tourCategoryedit?.email,
          mobile: res.data?.tourCategoryedit?.mobile,
          Pincode: res.data?.tourCategoryedit?.Pincode,
          city:res.data?.tourCategoryedit?.city,
          state:res.data?.tourCategoryedit?.state,
          Language:res.data?.tourCategoryedit?.Language,
          description: res.data?.tourCategoryedit?.description,
          status: res.data?.tourCategoryedit?.status,
        });
      })
      .catch((err) => console.log(err));
  }, [auth]);



  return (
    <div>
      <div className="row my-3">
        <div className="col-md-12">
          <h4 className="text-white">Edit Tour Category</h4>
        </div>
      </div>
      <div className="bg-white px-3 py-4 rounded-2  my-4">
        <div className="row">
         
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Place <span className="text-danger fs-4">*</span></Label>
              <Input
                value={formData?.place_id}
                type="select"
                name="place_id"
                onChange={inputHandler}
              >
                <option value="">Select Place</option>
                {places?.map?.((item) => {
                  return (
                    <option value={item.id} key={item.id}>
                      {item?.place_name}
                    </option>
                  );
                })}
              </Input>
              <span className="d-block text-danger">{errors?.place_id}</span>
             
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Tour Category <span className="text-danger fs-4">*</span></Label>
              <Input
                value={formData?.tour_category_id}
                type="select"
                name="tour_category_id"
                onChange={inputHandler}
              >
                <option value="">Select Tour Catgeory</option>
                
                    <option value="1" key="1">Tour Opreator </option>
                    <option value="2" key="2">Tour Guide </option>
                    <option value="3" key="3">Intermidator </option>
                    <option value="4" key="4">Route Planer </option>
                 
              </Input>
              <span className="d-block text-danger">{errors?.tour_category_id}</span>
             
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Name <span className="text-danger fs-4">*</span></Label>
              <Input
                invalid={Boolean(errors?.name)}
                value={formData?.name}
                name="name"
                onChange={inputHandler}
              />
              <span className="d-block text-danger"> {errors?.name} </span>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Email</Label>
              <Input
                invalid={Boolean(errors?.email)}
                value={formData?.email}
                name="email"
                onChange={inputHandler}
              />
              <span className="d-block text-danger"> {errors?.email} </span>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Mobile <span className="text-danger fs-4">*</span></Label>
              <Input
                invalid={Boolean(errors?.mobile)}
                value={formData?.mobile}
                name="mobile"
                onChange={inputHandler}
              />
              <span className="d-block text-danger"> {errors?.mobile} </span>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>State <span className="text-danger fs-4">*</span></Label>
              <Input
                invalid={Boolean(errors?.state)}
                value={formData?.state}
                name="state"
                onChange={inputHandler}
              />
              <span className="d-block text-danger"> {errors?.state} </span>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>City <span className="text-danger fs-4">*</span></Label>
              <Input
                invalid={Boolean(errors?.city)}
                value={formData?.city}
                name="city"
                onChange={inputHandler}
              />
              <span className="d-block text-danger"> {errors?.city} </span>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Pincode</Label>
              <Input
                invalid={Boolean(errors?.Pincode)}
                value={formData?.Pincode}
                name="Pincode"
                onChange={inputHandler}
              />
              <span className="d-block text-danger"> {errors?.Pincode} </span>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Language</Label>
              <Input
                value={formData?.Language}
                name="Language"
                onChange={inputHandler}
              />
              <span className="d-block text-danger"> {errors?.Language} </span>
            </FormGroup>
          </div>
        
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Upload Logo</Label>
              <Input
                type="file"
                invalid={Boolean(errors?.logo)}
                name="logo"
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    [e.target.name]: e.target.files[0],
                  }))
                }
              />
              <span className="d-block text-danger">{errors?.logo}</span>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Description <span className="text-danger fs-4">*</span></Label>
              <Input
                type="textarea"
                invalid={Boolean(errors?.description)}
                value={formData?.description}
                name="description"
                onChange={inputHandler}
              />
              <span className="d-block text-danger"> {errors?.description} </span>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup switch>
              <Input
                type="switch"
                checked={formData?.status}
                onChange={inputHandler}
                name="status"
              />
              <Label check>Status</Label>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-4">
            <Button color="primary" onClick={handleSubmit}>
              Submit
            </Button>
            <Button className="ms-3" onClick={() => navigate(-1)}>
              Cancel
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditTourCategory;
